import React from 'react';
import AdminInvitesSection from '../components/AdminInvitesSection';
import './AdminInvitesPage.css';

export default function AdminInvitesPage() {
  return (
    <div className="admin-invites-page">
      <div className="admin-invites-page-header">
        <h1>Admin Panel Invites</h1>
        <p>Manage admin and support user invitations</p>
      </div>
      <AdminInvitesSection showHeader={false} />
    </div>
  );
}
